//@flow
import React from 'react'

import { Flex } from 'components/common'
import { useLineDividerStyles } from './styles'

interface LineDividerProps {
  title?: string;
}

const LineDivider = ({ title, ...props }: LineDividerProps) => {
  const classes = useLineDividerStyles()

  if (title) {
    return (
      <Flex alignCenter>
        <h3 className={classes.title}>{title}</h3>
        <hr className={classes.lineDivider} style={{ flex: 1 }} {...props} />
      </Flex>
    )
  }

  return <hr className={classes.lineDivider} {...props} />
}

export default LineDivider
